<template>
  <div>
    <label class="section-title -mt-large -mb">Form fields:</label>
    <div v-for="(field, index) in editableFields" :key="index" class="halves">
      <!--
      --><input v-model="field.name" type="text" placeholder="Name" @input="change" /><!--
      --><select v-model="field.type" @change="change">
        <option value="text">String</option>
        <option value="email">Email</option>
        <option value="number">Number</option>
        <option value="select">Select</option></select
      ><!--
      -->
      <div v-if="field.type === 'select'">
        <input v-model="field.options" type="text" placeholder="Options (comma separated)" @input="change" />
      </div>

      <span v-if="error(index, 'name')" class="alert -inline -danger">Form field name {{ error(index, "name") }}</span>
      <span v-if="error(index, 'type')" class="alert -inline -danger">Form field type {{ error(index, "type") }}</span>

      <div v-for="(validation, vIndex) in field.validation" :key="vIndex" class="halves">
        <select v-model="validation.type" @change="change">
          <option value="required">Required</option>
          <option value="regex">Regex</option>
          <option value="min_length">Min Length</option>
          <option value="phone_number">Phone Number</option></select
        ><!--

        --><input v-model="validation.value" type="text" @input="change" />

        <span v-if="validationError(index, vIndex, 'value')" class="alert -inline -danger"
          >Validation value {{ validationError(index, vIndex, "value") }}</span
        >
        <br />
        <a href="#" class="button -danger -small -mb" @click.prevent="removeValidation(field, validation)"
          >Remove validation</a
        >
      </div>

      <a href="#" class="button -small" @click.prevent="addValidation(field)">Add validation</a>
      <a href="#" class="button -danger -small" @click.prevent="removeField(field)">Remove form field</a>

      <hr />
    </div>

    <a href="#" class="button -small" @click.prevent="addField">Add form field</a>
  </div>
</template>

<script>
import dig from "object-dig";
import _ from "underscore";

export default {
  name: "QueryResponses",

  props: {
    query: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    errors: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      editableFields: [],
      editableErrors: []
    };
  },

  watch: {
    query(newQuery, oldQuery) {
      // Only reset if loading different query (by ID change)
      if (!oldQuery || oldQuery.id !== newQuery.id) {
        this.setEditableFields();
      }
    },

    errors() {
      this.editableErrors = this.errors;
    }
  },

  mounted() {
    this.setEditableFields();
  },

  methods: {
    error(index, attr) {
      return dig(this.editableErrors, this.type, "form_fields", index, attr, 0);
    },

    validationError(fieldIndex, validationIndex, attr) {
      return dig(this.editableErrors, this.type, "form_fields", fieldIndex, "validation", validationIndex, attr, 0);
    },

    addField() {
      this.editableFields.push({ name: "", type: "text" });
      this.change();
    },

    removeField(formField) {
      this.editableFields = _.without(this.editableFields, formField);
      this.change();
    },

    addValidation(field) {
      this.editableFields = _.map(this.editableFields, (ff) => {
        if (ff === field) {
          ff.validation = ff.validation || [];
          ff.validation.push({ type: "required", value: "" });
        }
        return ff;
      });

      // this.$forceUpdate();
      this.change();
    },

    removeValidation(field, validation) {
      this.editableFields = _.map(this.editableFields, (ff) => {
        if (ff === field) {
          ff.validation = _.without(ff.validation, validation);
        }
        return ff;
      });

      // this.$forceUpdate();
      this.change();
    },

    change() {
      this.editableErrors = {};
      this.$emit("change", this.editableFields);
    },

    setEditableFields() {
      this.editableFields = dig(this.query, this.type, "form_fields");
    }
  }
};
</script>
